import * as Sentry from "@sentry/nextjs";

export function captureErrorBoundary(
  error: Error & { digest?: string },
  boundary: string,
  route?: string
): void {
  const path = typeof window !== "undefined" ? window.location.pathname : "unknown";

  Sentry.addBreadcrumb({
    category: "error-boundary",
    message: `Error boundary triggered: ${boundary}`,
    level: "error",
    data: {
      boundary,
      route: route || path,
      digest: error.digest,
      errorName: error.name,
    },
  });

  Sentry.captureException(error, {
    tags: {
      errorBoundary: boundary,
      route: route || path,
    },
    extra: {
      digest: error.digest,
      boundary,
      path,
    },
    fingerprint: ["error-boundary", boundary, error.name],
  });

  Sentry.getCurrentScope().clear();
}
